import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MyWorkBasketComponent } from './components/my-work-basket/my-work-basket.component'; 
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { WorkflowComponent } from './components/workflow/workflow.component';
import { RetrievalComponent } from './components/retrieval/retrieval.component';
import { WebUploadComponent } from './components/web-upload/web-upload.component';
import { DocumentViewerComponent } from './components/document-viewer/document-viewer.component';
import { DirectDocRetrievalComponent } from './shared/direct-doc-retrieval/direct-doc-retrieval.component';
import { VendorInfoComponent } from './components/vendor-info/vendor-info.component';
import { RoleGuard } from '../gaurds/role.guard';
import { PaymentCodeComponent } from './components/payment-code/payment-code.component';
import { SubstitutionComponent } from './components/substitution/substitution.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: MyWorkBasketComponent, canActivate: [OktaAuthGuard, RoleGuard] },
  { path: 'callback', component: OktaCallbackComponent, canActivate: [RoleGuard]  }, 
  { path: 'workflow', component: WorkflowComponent, canActivate: [OktaAuthGuard, RoleGuard] },
  { path: 'retrieval', component: RetrievalComponent, canActivate: [OktaAuthGuard, RoleGuard] },
  { path: 'webupload', component: WebUploadComponent, canActivate: [OktaAuthGuard, RoleGuard] },
  { path: 'documentViewer/:queueId/:docId/:instanceId/:type/:batchId', component: DocumentViewerComponent, canActivate: [OktaAuthGuard]  },
  { path: 'DDR/DirectDocumentRetrieval/:sys_id/:doc_id', component: DirectDocRetrievalComponent }, 
  { path: 'DDR/DirectDocumentRetrieval.html', component: DirectDocRetrievalComponent }, 
  { path: 'vendorinfo', component: VendorInfoComponent, canActivate: [OktaAuthGuard, RoleGuard]  },
  { path: 'paymentcode', component: PaymentCodeComponent, canActivate: [OktaAuthGuard,RoleGuard] },
  { path: 'substitution', component: SubstitutionComponent, canActivate: [OktaAuthGuard, RoleGuard] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
